<template>
  <!-- I added xm-top-navbar to make the css scoped. Using scoped style with vue loader, with deep >>> operators mostly worked, except I could not figure out why some color schemes
  would not be changed. This is a silly hack until someone wants to spend the time to fix it. -->
  <div class="xm-top-navbar">
    <div>
    <b-navbar class="navbar-dark" fixed="top" toggleable="lg">
    <div class="container">
      <b-navbar-brand :href="base">
        <img :src="brandUrl" alt="XMission" :class="{ 'xmBrand': isSignup }">
      </b-navbar-brand>
      <b-navbar-toggle target="XMMainNav" aria-controls="XMMainNav" aria-expanded="false" aria-label="Toggle navigation"/>
      <b-collapse id="XMMainNav" is-nav>
        <b-navbar-nav class="mr-auto">
          <b-nav-item>
            <b-nav-item-dropdown aria-haspopup="true" aria-expanded="false" aria-labelledby="businessMenu" no-caret text="Business" :menu-class="['submenu-business', 'businessMenu']">
              <b-dropdown-header>Internet Connections</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/xmission-business-fiber')">XMission Business Fiber</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_utopia')" link-class="subsub">&middot;	&nbsp; Business UTOPIA</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_bountiful')" link-class="subsub">&middot;	&nbsp; Bountiful Fiber</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_lehi')" link-class="subsub">&middot;	&nbsp; Lehi Fiber</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_southern_ute')" link-class="subsub">&middot;	&nbsp; Southern Ute</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_yellowstone')" link-class="subsub">&middot;	&nbsp; Yellowstone</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/xwi-smartsmb')">XWi Smart SMB</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/business_connectivity')">Other Connectivity</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Domain &amp; Hosting Services</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/domains')">Domain Services</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/web_hosting')">Shared Hosting</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/cloud_hosting')">Managed Cloud Hosting</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/vps')">Unmanaged Cloud Hosting</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/colocation')">Colocation</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/ssl')">SSL Certificates</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Email &amp; Collaboration Services</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/email_collaboration')">Hosted Zimbra Email</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/licensing')">Zimbra Licensing</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/reseller')">Private Label & Reseller</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Phone &amp; Professional Services</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/business_phone')">Business Phone Services</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/professional_services')">Professional Services</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item>
            <b-nav-item-dropdown aria-haspopup="true" aria-expanded="false" aria-labelledby="residentialMenu" no-caret text="Residential" href="#" :menu-class="['residentialMenu', 'submenu-residential']">
              <b-dropdown-header>Internet Connections</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/utopia')">UTOPIA</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/yellowstone_fiber')">Yellowstone Fiber</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/xmission-fiber-bountiful')">Bountiful Fiber</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/lehi')">Lehi Fiber</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Phone Service</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/voice')">Voice</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Domain &amp; Hosting Services</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/domains')">Domain Services</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/web_hosting')">Shared Hosting</b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-header>Email</b-dropdown-header>
              <b-dropdown-item @click="navigateTo('/personal_email')">Personal Premium Email</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item>
            <b-nav-item-dropdown aria-haspopup="true" aria-expanded="false" aria-labelledby="aboutMenu" no-caret text="About" href="#" menu-class="aboutMenu">
              <b-dropdown-item @click="navigateTo('/contact')">Contact Us</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/blog')">Blog</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/our_story')">Our Story</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/our_network')">Our Network</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/community')">Community</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/environment')">Environment</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/jobs')">Jobs</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/legal')">Legal</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/media')">Media</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/statistics')">Statistics</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/transparency')">Transparency</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/privacy-pledge')">Privacy Pledge</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item>
            <b-nav-item-dropdown aria-labelledby="supportMenu" aria-haspopup="true" aria-expanded="false" no-caret text="Support" href="#" menu-class="supportMenu">
              <b-dropdown-item @click="navigateTo('/support')">Resource&nbsp;Center</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/contact')">Contact Us</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/livesupport')">Live Support</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
        </b-navbar-nav>
        <!-- <div :class="['text-right', isLoggedIn ? 'xmNavWidgets' : '']">     -->
        <button  class="btn btn-outline-success" type="button" id="search-button" v-b-modal.search-xmission-modal><i class="bi bi-search"></i></button>
        <a v-if="!isLoggedIn" href="/login" class="btn btn-outline-danger"><b>login</b></a>
        <a v-else href="/control" class="btn" id="CtlUserTab">
          {{ username }}
          <small>logged in</small>
        </a>
        <!-- </div> -->
      </b-collapse>
    </div>
    <b-modal title="Search XMission" id="search-xmission-modal" hide-footer>
      <b-input-group>
        <b-form-input v-model="search_query"></b-form-input>
        <b-input-group-append>
          <b-button variant="success" @click="search()">
            Go
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
  </b-navbar>
  </div>
</div>
</template>


<style>
.xm-top-navbar nav {
    min-height:72px;
    padding: 0 0 0 0;
    background:#0f1113;
    backdrop-filter: blur(6px);
    flex-basis: auto;
}

.xm-top-navbar .container {background:transparent; padding-left: 15px; padding-right: 15px;}
.xm-top-navbar .navbar-brand img { margin-right:23px; }
.xm-top-navbar .navbar-brand img:hover {opacity:1}
.xm-top-navbar .dropdown-toggle::after {display:none}

.xm-top-navbar .dropdown-menu li .dropdown-item {
  padding:0px 20px 0px;
}

.xm-top-navbar .dropdown-menu li .dropdown-header {
  padding:0px 20px 0px;
}

.xm-top-navbar .dropdown-menu {
  border-radius:0;
  border:0;
  border-left:5px solid #464a4e;
  box-shadow: rgba(0,0,0,0.2) 0 0 40px;
  padding: 16px 0px 16px;
}

.xm-top-navbar li .dropdown-divider {
  margin-top:1em;
  border-color: transparent;
  border: 0;
  margin-bottom:0;
}
.xm-top-navbar .dropdown-header {
  font-size:12px;
  color:#5c6064;
  font-weight:bold;
  cursor: default;
}

#search-button{margin:0 10px;}

.btn-outline-danger {border-color:#EE4B00; color:#EE4B00 !important}
.btn-outline-danger:hover {background-color:#EE4B00; color:white !important}

.xm-top-navbar .businessMenu {border-color:#0290AE;}
.xm-top-navbar .residentialMenu {border-color:#B63A00;}
.xm-top-navbar .aboutMenu {border-color:#C5C8C9;}
.xm-top-navbar .supportMenu {border-color:#9EB231;}
.xm-top-navbar .submenu-business {width:250px}
.xm-top-navbar .submenu-residential {width:220px}

.xmNavWidgets {margin-top:17px}

#CtlUserTab {
  color:#222;
  line-height:normal;
  background:#ddd;
  padding:4px 16px 18px 16px;
  margin-left:18px;
  float:right;
  border-bottom-left-radius:0px;
  border-bottom-right-radius:0px;
  font-size:16px;
  margin-bottom: -18px;
  height: 56px;
}

#CtlUserTab small {display:block; font-size:10px; color:#555}

.darkMode #CtlUserTab {background: #1C1F22; color: #fff}


.xm-top-navbar .nav-pills .nav-link.active {background-color:#a7aaab;}


@media (max-width: 767px) {
  .xm-top-navbar .navbar-brand img {margin-top:-10px; width:180px; margin-right:23px; opacity:0.9}
}

.xm-top-navbar .dropdown-menu a:hover {text-decoration: underline;}

.liteMode a:hover {
  color: #02738b;
}
.liteMode a {
  color: #0290AE;
}


.darkMode .xm-top-navbar .nav-pills .nav-link.active {background-color:#333;}
.darkMode .xm-top-navbar .dropdown-menu {background-color:black; }
.darkMode .xm-top-navbar .dropdown-menu a {color:#ddd; background-color: black;}
.darkMode .xm-top-navbar .dropdown-menu li .dropdown-header:hover {background: black;}
.darkMode .xm-top-navbar .dropdown-menu li:hover {background:#222}
.darkMode .xm-top-navbar .dropdown-menu a:hover {color:white; text-decoration:none; background:#222}

.xmBrand {
  margin-top:-10px;
  width:200px;
  opacity:0.9;
  margin-right:23px;

}

#XMMainNav .subsub {
  padding-left:25px;
  font-size:90%;
  line-height:20px;
}

</style>


<script>
  import { BNavbar, BNavItem, BDropdown, BDropdownItem, BDropdownHeader, BDropdownDivider, BCollapse, VBToggle, BNavbarBrand, BNavbarToggle, BNavbarNav, BNavItemDropdown, BModal, VBModal, BFormInput, BInputGroup, BInputGroupAppend, BButton } from 'bootstrap-vue'
  import { mapGetters } from 'vuex'

  export default {
    mounted() {
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Control'){
          this.control = true
        }
      });
      window.addEventListener('keyup', (e) => {
        if (e.key === 'Control'){
          this.control = false
        }
      });
    },

    data () {
      return {
        base: 'https://xmission.com',
        control: false,
        search_query: ''
      }
    },

    computed: {
      ...mapGetters(['isLoggedIn', 'username']),
      isSignup() {
        return this.$route.name === 'signup'
      },
      brandUrl () {
        if (this.isSignup){
          return 'https://asset.xmission.com/xmweb3/XMission-logo.png'
        }
        return 'https://asset.xmission.com/xmweb3/xm-control-panel-logo.png'
      }
    },

    methods: {
      navigateTo(page) {
        if (this.control) {
          window.open(this.base + page,'_blank')
        }
        else {
          window.location.href =  this.base + page
        }
      },
      search() {
        window.location.href = this.base + '?s=' + this.search_query
      }
    },

    components: {
      BNavbar,
      BNavbarBrand,
      BNavbarToggle,
      BNavbarNav,
      BNavItem,
      BDropdown,
      BDropdownItem,
      BDropdownHeader,
      BDropdownDivider,
      BCollapse,
      BNavItemDropdown,
      BModal,
      BFormInput,
      BInputGroup,
      BInputGroupAppend,
      BButton
    },
    directives: {
      'b-toggle': VBToggle,
      'b-modal': VBModal
    }
  }
</script>



// WEBPACK FOOTER //
// TopNavbar.vue?074f8e14